// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import Notice2Form from "../../forms/anounce/Notice-of-Dissolution-2nd-Publication/NoticeofDissolution2ndPublication";

function Notice2Page() {
  return (
    <FormWrapper
      title="เลิกบริษัทประกาศเลิกขั้นตอนที่2"
      FormComponent={Notice2Form}
      formKey="notice-dissolution-2nd" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default Notice2Page;
